import React from 'react';
import 'antd/dist/antd.css';
import 'ant-design-pro/dist/ant-design-pro.css';
import DashboardTable from './DashboardTable';
import { Col, Row, Card, Tabs } from 'antd';
import {
  DashboardOutlined,
} from '@ant-design/icons';

const { TabPane } = Tabs;

const Dashboard = () => {

  return (
    <React.Fragment>
      <Row>
        <Col className="gutter-row" span={24}>
          <Card>
            <Tabs>
              <TabPane
                tab={
                  <span>
                    <DashboardOutlined />
                    Panel
                  </span>
                }
                key="0"
              >
                <DashboardTable />
              </TabPane>
            </Tabs>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard;